<template lang="html">
  <div>
    <div
    :class=" 'bg-'+$attrs.colour.bg "
    class="h-screen fixed left-0 top-0 z-0 w-full"></div>
    <div
    class="h-screen left-0 fixed z-20 w-full top-0"
    :style="{ backgroundImage : 'url(' + $attrs.colour.img + ')' }"
    ></div>
    <Stripes v-if="$attrs.stripes" :class=" $attrs.adapt + ' z-10 mb-12 animated bounceInUp slow'" />
  </div>
</template>

<script>
  import Stripes from "@/components/footer/stripes/Stripes.vue";
  export default {
    components: {
      Stripes
    }
  }
</script>
